import { Injectable } from '@angular/core';
import { PlanFeature, PlanInformation } from '../model/response/account-response';

@Injectable({ providedIn: 'root' })
export class PlanFeatureService {
  private features: PlanFeature[] = [];
  private _planId: string | null = null;
  private _billingType: 'stripe' | 'manual' | null = null;

  get planId(): string | null {
    return this._planId;
  }

  get billingType(): 'stripe' | 'manual' | null {
    return this._billingType;
  }

  load(planInformation: PlanInformation | null | undefined): void {
    this.features = planInformation?.features ?? [];
    this._planId = planInformation?.planId ?? null;
    this._billingType = planInformation?.billingType ?? null;
  }

  hasFeature(key: string): boolean {
    return this.features.some(f => f.key === key && f.value === 'true');
  }

  /** Espelha o AcceptsTier da API: sem TunerTier ou com "free", o vínculo com tuner é recusado. */
  canLinkToTuner(): boolean {
    const tier = this.features.find(f => f.key === 'TunerTier')?.value?.trim().toLowerCase();
    return !!tier && tier !== 'free';
  }

  featureLimit(key: string): number {
    const val = this.features.find(f => f.key === key)?.value;
    return val !== undefined ? parseInt(val, 10) : 0;
  }
}
